import DetailOrderInfo from "./detailOrderInfo.jsx";

export default DetailOrderInfo;
